export class FormDirty {
  private dirty: boolean;

  constructor() {}

  isDirty(): boolean {
    return this.dirty;
  }

  markAsDirty(): void {
    this.dirty = true;
  }

  markAsClean(): void {
    this.dirty = false;
  }
}
